import { render } from "./CalendarCard.vue?vue&type=template&id=d503aabc&scoped=true&ts=true"
import script from "./CalendarCard.vue?vue&type=script&lang=ts"
export * from "./CalendarCard.vue?vue&type=script&lang=ts"

import "./CalendarCard.vue?vue&type=style&index=0&id=d503aabc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d503aabc"]])

export default __exports__